import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { EnvironmentFeatures } from '@era/app';
import { Location } from '@era/locations-sdk';
import { LocationsRouterStoreSelectors, LocationSubset, RouterStoreStates } from '@era/stores';
import { EnvironmentService } from '@methylium/core';
import { NgbDropdownButtonItem, NgbDropdownItem, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  ContextMenuComponent,
  MasterComponent,
  MasterDetailComponent,
  PanelComponent,
  PanelHeaderComponent,
} from '@rocksoft/cdk';
import { Observable } from 'rxjs';
import { RebootDevicesModalContainerComponent } from '../../sub-features/reboot-devices-modal/reboot-devices-modal.container';
import { DevicesAssignedContainerComponent } from '../devices-assigned/devices-assigned.container';
import { DevicesBarContainerComponent } from '../devices-bar/devices-bar.container';
import { DevicesFrontDeskContainerComponent } from '../devices-frontdesk/devices-frontdesk.container';
import { DevicesHousekeepingContainerComponent } from '../devices-housekeeping/devices-housekeeping.container';
import { DevicesKioskContainerComponent } from '../devices-kiosk/devices-kiosk.container';
import { DevicesSpareContainerComponent } from '../devices-spare/devices-spare.container';
import { DevicesStaffContainerComponent } from '../devices-staff/devices-staff.container';
import { DevicesSwappedContainerComponent } from '../devices-swapped/devices-swapped.container';
import { DevicesSyncModalContainerComponent } from '../devices-sync-modal/devices-sync-modal.container';
import { SelectLocationListDevicesContainerComponent } from '../select-location/select-location-list-devices/select-location-list-devices.container';

@Component({
  selector: 'era-location-devices',
  templateUrl: './location-devices.component.html',
  styleUrls: ['./location-devices.component.scss'],
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    SelectLocationListDevicesContainerComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    MasterDetailComponent,
    MasterComponent,
    DevicesSwappedContainerComponent,
    DevicesSpareContainerComponent,
    DevicesAssignedContainerComponent,
    DevicesHousekeepingContainerComponent,
    DevicesStaffContainerComponent,
    DevicesFrontDeskContainerComponent,
    DevicesBarContainerComponent,
    DevicesKioskContainerComponent,
    AsyncPipe,
  ],
})
export class LocationDevicesComponent {
  public readonly features: EnvironmentFeatures;
  public readonly currentLocation$: Observable<Location>;

  constructor(
    private readonly modalService: NgbModal,
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly environmentService: EnvironmentService
  ) {
    this.features = this.environmentService.environment.features;
    this.currentLocation$ = this.routerStore.select(LocationsRouterStoreSelectors.selectLocation);
  }

  public openRebootRequest(): void {
    const modal = this.modalService.open(RebootDevicesModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.All;
  }

  public openSyncModalRequest(): void {
    const modal = this.modalService.open(DevicesSyncModalContainerComponent, {
      backdrop: 'static',
      centered: true,
      size: 'lg',
    });
    modal.componentInstance.locationSubset = LocationSubset.All;
  }
}
